import React from 'react';
import Questions from '../Survey/Questions';
import { parseDate } from '../../utils/helper';

const QuestionsList = ({ questions, setAnswer, setMultipleValue }) => {
  const getAnswer = (type, answer) => {
    const userFreeTypes = ['text', 'textarea', 'date', 'phone', 'number'];
    const multiAnswer = ['checkbox'];
    if (!answer || !answer.length) return '';
    if (type === 'date') return parseDate(answer[0].answer_text);
    if (multiAnswer.includes(type))
      return answer.map((a) =>
        typeof a === 'object' ? a.id.toString() : a.toString()
      );
    if (userFreeTypes.includes(type)) return answer[0].answer_text;
    const ans = typeof answer[0] === 'object' ? answer[0].id : answer[0];
    return ans || '';
  };

  return (
    <div>
      {questions.map((question, index) => (
        <div key={index} style={{ margin: '10px 0' }}>
          <div>{question.text}</div>
          <Questions
            value={getAnswer(question.question_type, question.answer)}
            type={question.question_type}
            options={question.answer_options}
            multiValue={getAnswer(question.question_type, question.answer)}
            setMultipleValue={(value) => setMultipleValue(question.id, value)}
            setAnswer={(value) => setAnswer(question.id, value)}
            noValidation
          />
        </div>
      ))}
    </div>
  );
};

export default QuestionsList;
